export default __webpack_public_path__ + "static/sky-fd003dcb60282f1c9415133ee20d6387.webp";